import { TypeOffreEnum } from '../../shared/constants/type-offre.enum';
import { SousTypeTauxEnum } from '../../shared/constants/sous-type-taux.enum';
import { TypeRemboursementEnum } from '../../shared/constants/type-remboursement.enum';

export interface TauxGarantiModel {
  idOffreTarificationBancaire?: string;
  idRepertoireProduitTerme?: string;
  tauxPersonnalise: number;
  tauxPreferentielCourant: number;
  valEcartPersonnalise?: number;
  tauxPlafond?: number;
  dateExpirationGarantieTaux: string;
  indSelectionMembre?: boolean;
  indPromotion: boolean;
  sousTypeTaux: SousTypeTauxEnum;
  nbrUniteTerme: number;
  frequenceTerme: FrequenceTermeEnum;
  typeRemboursement: TypeRemboursementEnum;
  typeOffre: TypeOffreEnum;
  valEcartAnneeSubsequente?: number;
  montantRemise: number;
}

export enum FrequenceTermeEnum {
  Ans = 'Ans',
  Mois = 'Mois'
}
